import React, { useEffect, useState } from "react";

import Dashboard from "./Dashboard";

import "./DashboardContainer.css";


const getSubSection = (activeSection) => {
  switch (activeSection) {

    case "PARCOURS":
      return [
        "Profil",
        "Auto-formation",
      ];

    case "EXPÉRIENCE":
      return [
        "Professionnelle",
        "Freelance",
        "Projets phares",
        "Open Source",
        "En cours",
      ];

    case "COMPÉTENCES":
      return [
        "Outils",
        "Langues parlées",
      ];

    case "MÉTHODOLOGIE":
      return [
        "Process",
        "Architecture",
        "Conseil",
      ];

    case "SOFT SKILLS":
      return [
        "Relationnel",
        "Organisation",
      ];

    case "RESSOURCES":
      return [
        "CV PDF",
        "Me joindre",
      ];

    default:
      return [
        "Profil",
        "Auto-formation",
      ];
  }
};


const DashboardContainer = () => {

  const [activeSection, setActiveSection] =
    useState("MÉTHODOLOGIE");

  const subSections =
    getSubSection(activeSection);

  const [
    activeSubSection,
    setActiveSubSection,
  ] = useState(subSections[0]);


  useEffect(() => {

    const newSubSections =
      getSubSection(activeSection);

    setActiveSubSection(
      newSubSections[0]
    );

  }, [activeSection]);


  return (
    <div className="dashboard-container">


      <Dashboard
        activeSection={activeSection}
        listSubSections={subSections}
        setActiveSubSection={setActiveSubSection}
        activeSubSection={activeSubSection}
      />

    </div>
  );
};


export default DashboardContainer;